/**
 * Search Toggle Module
 * Handles opening/closing the search form
 */

export default function initSearchToggle() {
  const searchTrigger = document.querySelector('[aria-label="Search"]');
  const searchForm = document.querySelector(".searchform");

  if (!searchTrigger || !searchForm) return;

  searchTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    searchForm.classList.toggle("active");

    // Focus the input when opening
    if (searchForm.classList.contains("active")) {
      const input = searchForm.querySelector('input[type="text"]');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  });

  // Close on ESC key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && searchForm.classList.contains("active")) {
      searchForm.classList.remove("active");
    }
  });

  // Optional: Close when clicking outside
  document.addEventListener("click", (e) => {
    if (
      searchForm.classList.contains("active") &&
      !searchForm.contains(e.target) &&
      !searchTrigger.contains(e.target)
    ) {
      searchForm.classList.remove("active");
    }
  });
}
